import BestBuyLogo from "../../assets/bestBuyLogo.svg";

export const SourceLogo = ({source}) => {
    if (source === "BEST_BUY" || source === "bestbuy") {
        return (
            <img
                src={BestBuyLogo}
                alt="Best Buy"
                className="h-auto w-14 object-contain"
            />
        );
    }
    return null;
};